import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

function LoginLinks(props) {
  const { forgotLink } = props;

  return (
    <Container className="mt--5 pb-5">
      <Row className="justify-content-center">
        <Col lg="6" md="8">
          <Row className="mt-3">
            <Col xs="6" className="text-center mx-0 px-0">
              <button type="button" id="forgot-button"
                      className="btn btn-link text-light" onClick={forgotLink}>
                <><FormattedMessage id="app.login.forgot_password_link"/></>
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

LoginLinks.defaultProps = {
  forgotLink: () => {
  },
};

export { LoginLinks };
